import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { Simdata5gorderAction } from 'src/actions/simdata5gorder.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getSimdata5gorderStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Select as Select1,
  MenuItem,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

const Simdata5gorderLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedSimdata5gorderIds, setSelectedSimdata5gorderIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.simdata5gorder);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(Simdata5gorderAction.updateFilter(payload));
    dispatch(Simdata5gorderAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedSimdata5gorderIds;

    if (event.target.checked) {
      newSelectedSimdata5gorderIds = items.map((simdata5gorder) => simdata5gorder.id);
    } else {
      newSelectedSimdata5gorderIds = [];
    }

    setSelectedSimdata5gorderIds(newSelectedSimdata5gorderIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedSimdata5gorderIds.indexOf(id);
    let newSelectedSimdata5gorderIds = [];

    if (selectedIndex === -1) {
      newSelectedSimdata5gorderIds = newSelectedSimdata5gorderIds.concat(selectedSimdata5gorderIds, id);
    } else if (selectedIndex === 0) {
      newSelectedSimdata5gorderIds = newSelectedSimdata5gorderIds.concat(selectedSimdata5gorderIds.slice(1));
    } else if (selectedIndex === selectedSimdata5gorderIds.length - 1) {
      newSelectedSimdata5gorderIds = newSelectedSimdata5gorderIds.concat(selectedSimdata5gorderIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedSimdata5gorderIds = newSelectedSimdata5gorderIds.concat(
        selectedSimdata5gorderIds.slice(0, selectedIndex),
        selectedSimdata5gorderIds.slice(selectedIndex + 1)
      );
    }

    setSelectedSimdata5gorderIds(newSelectedSimdata5gorderIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, simdata5gorder) => {
    setSelected(simdata5gorder);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(Simdata5gorderAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(Simdata5gorderAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'da_thanh_toan') return 'green';
    else if (value == 'chua_thanh_toan') return 'red';
    else if (value == 'online') return 'green';
    else if (value == 'cod') return 'blue';
    else if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  const setTrangThaiThuTien = async (id, value) => {
    dispatch(Simdata5gorderAction.update(id, { 
      trang_thai: value,
    }))
  }

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1500 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Thông tin khách hàng
                </TableCell>
                <TableCell>
                  Thông tin đặt hàng
                </TableCell>
                <TableCell>
                  Trạng thái
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((simdata5gorder, index) => (
                simdata5gorder ? <TableRow
                  hover
                  key={simdata5gorder.id}
                  selected={selectedSimdata5gorderIds.indexOf(simdata5gorder.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    - <span style={{fontWeight: 'bold'}}>SĐT:</span> <span style={{color: 'blue', fontWeight: 'bold'}}>{simdata5gorder.phone}</span><br></br>
                    - <span style={{fontWeight: 'bold'}}>Tên:</span> {simdata5gorder.name}<br></br>
                    - <span style={{fontWeight: 'bold'}}>Địa chỉ:</span> {simdata5gorder.address}<br></br>
                    - <span style={{fontWeight: 'bold'}}>Phương thức thanh toán:</span> <span style={{color: setColor(simdata5gorder.payment_method)}}>{simdata5gorder.payment_method == 'online' ? 'Chuyển khoản' : 'Khi nhận sim'}</span><br></br>
                    - <span style={{fontWeight: 'bold'}}>Thời điểm đặt:</span> {moment(simdata5gorder.createdAt).format('DD-MM-YYYY HH:mm:ss')}<br></br>
                    - <span style={{fontWeight: 'bold'}}>Ghi chú:</span> {simdata5gorder.note}<br></br>
                  </TableCell>
                  <TableCell>
                    - <span style={{fontWeight: 'bold'}}>Tên sản phẩm đặt:</span> <span style={{color: 'teal', fontWeight: 'bold'}}>{simdata5gorder.ordered_name}</span><br></br>
                    - <span style={{fontWeight: 'bold'}}>Số lượng đặt:</span> <span style={{color: 'red', fontWeight: 'bold'}}>{numeral(simdata5gorder.quantity).format('0,0')}</span><br></br>
                    - <span style={{fontWeight: 'bold'}}>Giá bán:</span> {numeral(simdata5gorder.ordered_price).format('0,0')}<br></br>
                    - <span style={{fontWeight: 'bold'}}>Nhà mạng:</span> <span style={{color: setColor(simdata5gorder.ordered_operator)}}>{simdata5gorder.ordered_operator}</span><br></br>
                    - <span style={{fontWeight: 'bold'}}>Thời hạn theo tháng:</span> {`${simdata5gorder.ordered_time_by_month} tháng`}<br></br>
                  </TableCell>
                  <TableCell>
                    <Select1 
                      style={{
                          fontSize: '14px',
                          width: '200px',
                          marginBottom: '15px',
                          color: setColor(simdata5gorder.trang_thai)
                        }}
                        variant="outlined"
                        value={simdata5gorder.trang_thai}
                        onChange={(e) =>
                          setTrangThaiThuTien(simdata5gorder.id, e.target.value)
                        }
                      >
                      <MenuItem
                        style={{ color: setColor('da_thanh_toan') }}
                        value="da_thanh_toan"
                      >
                        Đã thanh toán
                      </MenuItem>
                      <MenuItem
                        style={{ color: setColor('chua_thanh_toan') }}
                        value="chua_thanh_toan"
                      >
                        Chưa thanh toán
                      </MenuItem>
                    </Select1>
                  </TableCell>
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default Simdata5gorderLookupDetail;
